import React, { Component } from 'react';
// import { RouteChildrenProps } from 'react-router-dom';
import regbanner from '../../../assets/icons/accountAlreadyExists.png';
import Button from '../../UI/Button/Button';
import { statusUrl } from '../../utils/constants';
import mixpanelService from '../../Services/mixpanelService';
import mixpanelEvents, { getScreenName } from '../../../config/mixpanelEvents';
import './StatusVerified.scss';

interface IStatusVerifiedProps { }

class StatusVerified extends Component<IStatusVerifiedProps> {
    checkStatus = () => {
        try {
            const screen_name = getScreenName(window.location.pathname);
            if (screen_name) {
                mixpanelService({
                    event: mixpanelEvents.CTA_CLICKED,
                    screen_name,
                    text: "Use a different PAN",
                    cta_type: "sticky",
                    cta_class: "secondary",
                    cta_service: "AOJ",
                });
            }
        } catch (e) {
            console.error("mixpanel cta_clicked failed", e);
        }
        window.location.href = statusUrl.statusHome;
    };

    render() {
        return (
            <div className="status-verification-root" role="status" aria-live="polite" aria-atomic="true">
                <img src={regbanner} className="verified-img" alt="Account status" />
                <div>
                    <h2 className="status-heading">Account Already Exists</h2>
                    <span className="status-subHead">
                        An account already exists with this PAN
                        <br /> and mobile information.
                    </span>
                    <div className="login-btn">
                        <Button btnName="Need Login Help?" type="submit" />
                    </div>
                    <div className="new-pan-entry">
                        <span className="alreadyAccountLabel">Entered PAN by mistake? </span>
                        <button type="button" className="loginLink" onClick={this.checkStatus}>
                            Use a different PAN
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default StatusVerified;
